export default __webpack_public_path__ + "static/media/location.58af6310.svg";